import React from 'react';
import { FadeIn } from './FadeIn';
import { useLanguage } from './LanguageContext';
export function HeroSection() {
  const {
    t
  } = useLanguage();
  return <section className="relative min-h-[60vh] sm:min-h-[80vh] flex items-center justify-center overflow-hidden" data-id="element-193">
      <div className="absolute inset-0 z-0" data-id="element-194">
        <img src="https://cdn.magicpatterns.com/uploads/6J7YcyUvgP1Kog7Y5PLsHq/banner.png" alt="Estructura metálica ARCO" className="w-full h-full object-cover object-center sm:object-center" data-id="element-195" />
        <div className="absolute inset-0 bg-navy-900/85 sm:bg-navy-900/80 mix-blend-multiply" data-id="element-196"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-navy-900/60 via-transparent to-navy-900" data-id="element-197"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-5 sm:px-6 lg:px-8 text-center pt-12 pb-16 sm:pt-20 sm:pb-24" data-id="element-198">
        <FadeIn delay={0.1} data-id="element-199">
          <h1 className="font-black tracking-tight leading-[1.1] mb-4 sm:mb-6 drop-shadow-lg" data-id="element-200">
            <span className="block text-metallic text-3xl sm:text-5xl md:text-6xl lg:text-7xl" data-id="element-201">
              {t('hero.title1')}
            </span>
            <span className="block text-metallic text-2xl sm:text-4xl md:text-5xl font-bold tracking-[0.15em] sm:tracking-[0.25em] my-2 sm:my-4" data-id="element-202">
              {t('hero.title2')}
            </span>
            <span className="block text-metallic text-3xl sm:text-5xl md:text-6xl lg:text-7xl" data-id="element-203">
              {t('hero.title3')}
            </span>
          </h1>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-204">
          <p className="mt-4 sm:mt-6 text-base sm:text-xl md:text-2xl text-gray-200 max-w-3xl mx-auto font-medium leading-relaxed drop-shadow-md" data-id="element-205">
            {t('hero.subtitle')}
          </p>
        </FadeIn>

        <FadeIn delay={0.5} data-id="element-206">
          <div className="mt-8 sm:mt-10" data-id="element-207">
            <a href="#contacto" className="inline-flex items-center justify-center px-6 sm:px-8 py-3 sm:py-4 text-base sm:text-lg font-bold rounded-md text-navy-900 bg-amber hover:bg-amber-light transition-colors duration-300 uppercase tracking-wider shadow-lg hover:shadow-amber/50" data-id="element-208">
              {t('hero.cta')}
            </a>
          </div>
        </FadeIn>
      </div>
    </section>;
}